import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: "absolute",
  },
  openContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
  },
  logoContainer: {
    paddingLeft: 46,
    paddingRight: 46,
    [theme.breakpoints.down("desktop")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    cursor: "pointer",
  },
  logo: {
    width: 40,
    height: 47,
  },
  titleContainer: {
    marginTop: 9,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 0,
    },
  },
  title: {
    fontSize: theme.fontSizes.md,
    color: theme.colors.greenText,
    [theme.breakpoints.down("desktop")]: {
      marginTop: theme.fontSizes.default,
    },
  },
  subTitleContainer: {
    marginTop: -5,
    [theme.breakpoints.down("desktop")]: {
      display: "none",
    },
    maxWidth: 300,
    whiteSpace: "initial",
  },
  subTitle: {
    color: theme.colors.primaryGreen,
    fontSize: theme.fontSizes.smd,
    width: "100%",
    wordWrap: "initial",
  },
  navContainer: {
    marginTop: 50,
    width: "100%",
    minHeight: 330,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 25,
      minHeight: "calc(100vh - 390px)",
    },
  },
  footer: {
    width: "100%",
    paddingLeft: 46,
    paddingRight: 46,
    [theme.breakpoints.down("desktop")]: {
      paddingLeft: 20,
      paddingRight: 20,
      marginTop: "46px",
    },
  },
  item: {
    paddingLeft: "40px !important",
    paddingRight: "40px !important",
    ...(theme.direction !== "rtl" ? { borderLeft: "6px solid transparent !important" } : { borderRight: "6px solid transparent !important" }),
    paddingTop: "15px !important",
    paddingBottom: "15px !important",
    height: 54,
    [theme.breakpoints.down("desktop")]: {
      height: 44,
      paddingTop: "0px !important",
      paddingLeft: "20px !important",
      paddingRight: "20px !important",
      borderLeftWidth: "0px !important",
      borderRightWidth: "0px !important",
    },
    ["&:not(first-child)"]: {
      marginTop: 18,
    },
  },
  itemActive: {
    ...(theme.direction !== "rtl"
      ? { borderLeft: `6px solid ${theme.colors.primaryGreen} !important` }
      : { borderRight: `6px solid ${theme.colors.primaryGreen} !important` }),
    [theme.breakpoints.down("desktop")]: {
      borderLeftWidth: "0px !important",
      borderRightWidth: "0px !important",
    },
  },
  menuLabel: {
    fontSize: theme.fontSizes.default,
    [theme.breakpoints.down("desktop")]: {
      fontSize: theme.fontSizes.md,
    },
  },
  menuLabelActive: {
    fontWeight: 600,
  },
  itemContainer: {
    alignItems: "center",
  },
  icon: {
    width: "26px",
    height: "26px",
    ...(theme.direction === "rtl" ? { marginLeft: 20 } : { marginRight: 20 }),
    [theme.breakpoints.down("desktop")]: {
      ...(theme.direction === "rtl" ? { marginLeft: 17 } : { marginRight: 17 }),
    },
  },
  closedContainer: {
    width: "100%",
  },
  closedLogoContainer: {
    paddingLeft: 11,
    paddingRight: 11,
    cursor: "pointer",
  },
  closedTitleContainer: {
    width: 63,
    textAlign: "center",
    cursor: "pointer",
  },
  closedTitle: {
    fontSize: theme.fontSizes.xs,
    color: theme.colors.greenText,
  },
  closedNavContainer: {
    marginTop: 81,
    width: "100%",
  },
  closedItem: {
    height: 54,
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
    ...(theme.direction !== "rtl" ? { borderLeft: "6px solid transparent !important" } : { borderRight: "6px solid transparent !important" }),
    paddingTop: "15px !important",
    paddingBottom: "15px !important",
    ["&:not(first-child)"]: {
      marginTop: 18,
    },
  },
  closedItemActive: {
    ...(theme.direction !== "rtl"
      ? { borderLeft: `6px solid ${theme.colors.primaryGreen} !important` }
      : { borderRight: `6px solid ${theme.colors.primaryGreen} !important` }),
  },
  closedItemIconContainer: {
    width: 29,
  },

  termsAndPrivacy_container: {},

  logout_container: {
    margin: "0px 48px",
    marginBottom: "20px",
    fontSize: "16px",
    textDecoration: "underline",
    cursor: "pointer",
    userSelect: "none",
  },

  logout_container_mobile: {
    margin: "0px 24px",
    marginTop: "20px",
    fontSize: "16px",
    textDecoration: "underline",
    cursor: "pointer",
    userSelect: "none",
  },

  contact_container: {
    margin: "0px 48px",
    marginBottom: "20px",
    fontSize: "16px",
    // textDecoration: "underline",
    cursor: "pointer",
    userSelect: "none",
  },

  contact_container_mobile: {
    margin: "0px 24px",
    marginTop: "20px",
    fontSize: "16px",
    textDecoration: "underline",
    cursor: "pointer",
    userSelect: "none",
  },
}));

export default useStyles;
